import { closeIcon } from "assets/images";
import { Button, Dropdown, GroupInput, Input, Label } from "common/components";
import React, { useState } from "react";

function AddEducationModal(props) {
  const { setShow, show, data, setData } = props;
  const degrees = [
    { id: "Post Graduate", name: "Post Graduate" },
    { id: "BTech", name: "BTech" },
  ];
  let [fieldValues, setFieldValue] = useState({});
  let [errors, setErrors] = useState({});
  let tmpData = [];
  if (data) {
    tmpData = structuredClone(data);
  }

  const handleChange = (e, key, file) => {
    let data;

    if (file) {
      data = e.target.files[0];
    } else {
      data = e.target.value;
    }

    fieldValues[key] = data;
    setFieldValue({ ...fieldValues });
  };

  const handleSave = () => {
    let errors = {};
    if (!fieldValues.degreeField) {
      errors.degreeField = "This field is required";
    }
    if (!fieldValues.degreepercent) {
      errors.degreepercent = "This field is required";
    } else if (isNaN(fieldValues.degreepercent) || fieldValues.degreepercent < 1 || fieldValues.degreepercent > 100) {
      errors.degreepercent = "Degree percent must be a number between 0 and 100";
    }
    if (!fieldValues.degreefile) {
      errors.degreefile = "This field is required";
    }

    if (Object.keys(errors).length) {
      setErrors({ ...errors });
      return;
    }

    if (tmpData.length > 0) {
      tmpData.push(fieldValues);
    } else {
      tmpData = [fieldValues];
    }
    setData(tmpData);
    setShow(false);
  };

  return (
    <div className="d-flex align-items-center justify-content-center mb-4 ">
      <div className="relative pt-4 bordermodal">
        <div
          className="closeIcon"
          onClick={() => {
            setShow(false);
          }}
        >
          <img src={closeIcon} />
        </div>

        <Label label="Degree" required />
        <Dropdown
          placeholder="Postgraduate"
          name="degreeField"
          value={fieldValues.degreeField}
          options={degrees}
          onChange={(e) => handleChange(e, "degreeField")}
          error={errors.degreeField}
          touched={true}
        />

        <Label label="Passing Percentage" required />
        <GroupInput
          type="text"
          placeholder="Passing Percentage"
          name="degreepercent"
          value={fieldValues.degreepercent}
          onChange={(e) => handleChange(e, "degreepercent")}
          group="%"
          error={errors.degreepercent}
          touched={true}
        />
        <Label label="Upload Result" required />
        <Input
          accept="image/* , .pdf"
          type="file"
          name="degreefile"
          onChange={(e) => handleChange(e, "degreefile", true)}
          error={errors.degreefile}
          touched={true}
        />
        <div className="d-flex justify-content-end pt-2">
          <Button onClick={handleSave} type="button" label="Save" />
        </div>
      </div>
    </div>
  );
}

export default AddEducationModal;
